'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var SpecialEventsGridController = function SpecialEventsGridController($scope, $rootScope, configurationService, specialEventsCsvService) {
  var eventsMap = _.transform(configurationService.getEvents(), function (result, event) {
    result[event.name] = event.type;
    return result;
  }, {});
  $scope.initEventsGrid = function () {
    $scope.gridData = $scope.displayedCalendar.specialEvents;
    $scope.calendarName = $scope.displayedCalendar.calendarName;
    $scope.calendarStatus = $scope.displayedCalendar.calendarStatus;
    $scope.calendarMarket = $scope.displayedCalendar.market;
  };
  $scope.isImportButtonShown = false;
  $scope.setEventType = function (event) {
    var args = event.args;
    var type = '';
    if (args.datafield === 'eventName') {
      var matchingType = eventsMap[args.value];
      if (args.value !== args.oldvalue) {
        var setCellValueParams = {
          rowId: args.row.uid,
          columnName: 'eventType',
          newValue: matchingType || type,
          oldValue: args.row.eventType,
          gridId: $scope.gridId
        };
        $rootScope.$broadcast('grid:setCellValue', setCellValueParams);
      }
    }
  };
  $scope.makeExportToCsv = function (data) {
    if (!data.length) {
      toastr.warning('Nothing to export');
      return;
    }
    specialEventsCsvService.exportToCsv(data, $scope.calendarName, $scope.calendarMarket);
  };
  $scope.handleSpecialEventUpdates = function (newSplEventsList, oldSplEventsList) {
    if (!_.isEqual(newSplEventsList, oldSplEventsList)) {
      $scope.initEventsGrid();
    }
  };
  $scope.hideIfReadOnly = function isReadOnly() {
    return !!!$scope.readOnly;
  };
};
SpecialEventsGridController.$inject = ['$scope', '$rootScope', 'ConfigurationService', 'SpecialEventsCsvService'];
module.exports = SpecialEventsGridController;